import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _assertThisInitialized from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from 'tslib';
import React from 'react';
import { matchPath, Redirect, Route, withRouter, BrowserRouter } from 'react-router-dom';
import { IonLifeCycleContext, DefaultIonLifeCycleContext, NavContext } from '@ionic/react';

var generateUniqueId = function generateUniqueId() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var charPool = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  var charArray = [];

  for (var i = 0; i < length; i++) {
    charArray.push(charPool[Math.floor(Math.random() * charPool.length)]);
  }

  return charArray.join('');
};

var ViewInternal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ViewInternal, _React$Component);

  function ViewInternal(props) {
    var _this;

    _classCallCheck(this, ViewInternal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ViewInternal).call(this, props));
    _this.state = {
      ref: null
    };
    return _this;
  }

  _createClass(ViewInternal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var forwardedRef = this.props.forwardedRef;
      this.setState({
        ref: forwardedRef
      });

      if (forwardedRef && forwardedRef.current) {
        forwardedRef.current.addEventListener('ionViewWillEnter', this.ionViewWillEnterHandler.bind(this));
        forwardedRef.current.addEventListener('ionViewDidEnter', this.ionViewDidEnterHandler.bind(this));
        forwardedRef.current.addEventListener('ionViewWillLeave', this.ionViewWillLeaveHandler.bind(this));
        forwardedRef.current.addEventListener('ionViewDidLeave', this.ionViewDidLeaveHandler.bind(this));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var forwardedRef = this.props.forwardedRef;

      if (forwardedRef && forwardedRef.current) {
        forwardedRef.current.removeEventListener('ionViewWillEnter', this.ionViewWillEnterHandler.bind(this));
        forwardedRef.current.removeEventListener('ionViewDidEnter', this.ionViewDidEnterHandler.bind(this));
        forwardedRef.current.removeEventListener('ionViewWillLeave', this.ionViewWillLeaveHandler.bind(this));
        forwardedRef.current.removeEventListener('ionViewDidLeave', this.ionViewDidLeaveHandler.bind(this));
      }
    }
  }, {
    key: "ionViewWillEnterHandler",
    value: function ionViewWillEnterHandler() {
      this.context.ionViewWillEnter();
    }
  }, {
    key: "ionViewDidEnterHandler",
    value: function ionViewDidEnterHandler() {
      this.context.ionViewDidEnter();
    }
  }, {
    key: "ionViewWillLeaveHandler",
    value: function ionViewWillLeaveHandler() {
      this.context.ionViewWillLeave();
    }
  }, {
    key: "ionViewDidLeaveHandler",
    value: function ionViewDidLeaveHandler() {
      this.context.ionViewDidLeave();
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          children = _a.children,
          forwardedRef = _a.forwardedRef,
          rest = __rest(_a, ["className", "children", "forwardedRef"]);

      var ref = this.state.ref;
      return React.createElement("div", Object.assign({
        className: className ? "ion-page ".concat(className) : 'ion-page',
        ref: forwardedRef
      }, rest), ref && children);
    }
  }], [{
    key: "contextType",
    get: function get() {
      return IonLifeCycleContext;
    }
  }]);

  return ViewInternal;
}(React.Component);

function forwardRef(props, ref) {
  return React.createElement(ViewInternal, Object.assign({
    forwardedRef: ref
  }, props));
}

forwardRef.displayName = 'View';
var View =
/*@__PURE__*/
React.forwardRef(forwardRef);
var RouteManagerContext =
/*@__PURE__*/
React.createContext({
  viewStacks: {},
  hideView: function hideView() {
    navContextNotFoundError();
  },
  setupIonRouter: function setupIonRouter() {
    navContextNotFoundError();
  },
  removeViewStack: function removeViewStack() {
    navContextNotFoundError();
  },
  renderChild: function renderChild() {
    navContextNotFoundError();
  },
  transitionView: function transitionView() {
    navContextNotFoundError();
  }
});

function navContextNotFoundError() {
  console.error('IonReactRouter not found, did you add it to the app?');
}

var ViewItemManager =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(ViewItemManager, _React$Component2);

  function ViewItemManager(props) {
    var _this2;

    _classCallCheck(this, ViewItemManager);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ViewItemManager).call(this, props));
    _this2.ionLifeCycleContext = new DefaultIonLifeCycleContext();
    _this2._isMounted = false;
    _this2.state = {
      show: true
    };

    _this2.ionLifeCycleContext.onComponentCanBeDestroyed(function () {
      if (!_this2.props.mount) {
        if (_this2._isMounted) {
          _this2.setState({
            show: false
          }, function () {
            _this2.context.hideView(_this2.props.id);
          });
        }
      }
    });

    return _this2;
  }

  _createClass(ViewItemManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var show = this.state.show;
      return React.createElement(IonLifeCycleContext.Provider, {
        value: this.ionLifeCycleContext
      }, show && this.props.children);
    }
  }], [{
    key: "contextType",
    get: function get() {
      return RouteManagerContext;
    }
  }]);

  return ViewItemManager;
}(React.Component);

var ViewManager =
/*#__PURE__*/
function (_React$Component3) {
  _inherits(ViewManager, _React$Component3);

  function ViewManager(props) {
    var _this3;

    _classCallCheck(this, ViewManager);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ViewManager).call(this, props));
    _this3.containerEl = React.createRef();
    _this3.id = _this3.props.id || generateUniqueId();
    return _this3;
  }

  _createClass(ViewManager, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.context.setupIonRouter(this.id, this.props.children, this.containerEl.current);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.context.removeViewStack(this.id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var context = this.context;
      var viewStack = context.viewStacks[this.id];
      var activeId = viewStack ? viewStack.activeId : '';
      var views = (viewStack || {
        views: []
      }).views.filter(function (x) {
        return x.show;
      });
      return React.createElement("ion-router-outlet", {
        "data-id": this.id,
        ref: this.containerEl
      }, views.map(function (item) {
        var props = {};

        if (item.id === activeId) {
          props = {
            'className': ' ion-page-invisible'
          };
        }

        return React.createElement(ViewItemManager, {
          id: item.id,
          key: item.key,
          mount: item.mount
        }, React.createElement(View, Object.assign({
          ref: item.ref
        }, props), _this4.context.renderChild(item)));
      }));
    }
  }], [{
    key: "contextType",
    get: function get() {
      return RouteManagerContext;
    }
  }]);

  return ViewManager;
}(React.Component);

var RESTRICT_SIZE = 25;

var LocationHistory =
/*#__PURE__*/
function () {
  function LocationHistory() {
    _classCallCheck(this, LocationHistory);

    this.locationHistory = [];
  }

  _createClass(LocationHistory, [{
    key: "add",
    value: function add(location) {
      this.locationHistory.push(location);

      if (this.locationHistory.length > RESTRICT_SIZE) {
        this.locationHistory.splice(0, 10);
      }
    }
  }, {
    key: "findLastLocation",
    value: function findLastLocation(url) {
      var reversedLocations = _toConsumableArray(this.locationHistory).reverse();

      var last = reversedLocations.find(function (x) {
        return x.pathname.toLowerCase() === url.toLowerCase();
      });
      return last;
    }
  }]);

  return LocationHistory;
}();

var NavManager =
/*#__PURE__*/
function (_React$Component4) {
  _inherits(NavManager, _React$Component4);

  function NavManager(props) {
    var _this5;

    _classCallCheck(this, NavManager);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(NavManager).call(this, props));
    _this5.locationHistory = new LocationHistory();
    _this5.state = {
      goBack: _this5.goBack.bind(_assertThisInitialized(_this5)),
      hasIonicRouter: function hasIonicRouter() {
        return true;
      },
      getHistory: _this5.getHistory.bind(_assertThisInitialized(_this5)),
      getLocation: _this5.getLocation.bind(_assertThisInitialized(_this5)),
      navigate: _this5.navigate.bind(_assertThisInitialized(_this5)),
      getViewManager: _this5.getViewManager.bind(_assertThisInitialized(_this5)),
      currentPath: _this5.props.location.pathname
    };
    _this5.listenUnregisterCallback = _this5.props.history.listen(function (location) {
      _this5.setState({
        currentPath: location.pathname
      });

      _this5.locationHistory.add(location);
    });

    _this5.locationHistory.add({
      hash: window.location.hash,
      key: generateUniqueId(6),
      pathname: window.location.pathname,
      search: window.location.search,
      state: {}
    });

    return _this5;
  }

  _createClass(NavManager, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.listenUnregisterCallback) {
        this.listenUnregisterCallback();
      }
    }
  }, {
    key: "goBack",
    value: function goBack(defaultHref) {
      var _this$props$findViewI = this.props.findViewInfoByLocation(this.props.location),
          leavingView = _this$props$findViewI.view;

      if (leavingView) {
        var _this$props$findViewI2 = this.props.findViewInfoById(leavingView.prevId),
            enteringView = _this$props$findViewI2.view;

        if (enteringView) {
          var lastLocation = this.locationHistory.findLastLocation(enteringView.routeData.match.url);

          if (lastLocation) {
            this.props.history.replace(lastLocation.pathname + lastLocation.search, {
              direction: 'back'
            });
          } else {
            this.props.history.replace(enteringView.routeData.match.url, {
              direction: 'back'
            });
          }
        } else {
          defaultHref && this.props.history.replace(defaultHref, {
            direction: 'back'
          });
        }
      } else {
        defaultHref && this.props.history.replace(defaultHref, {
          direction: 'back'
        });
      }
    }
  }, {
    key: "getHistory",
    value: function getHistory() {
      return this.props.history;
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      return this.props.location;
    }
  }, {
    key: "navigate",
    value: function navigate(path, direction) {
      this.props.history.push(path, {
        direction: direction
      });
    }
  }, {
    key: "getViewManager",
    value: function getViewManager() {
      return ViewManager;
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(NavContext.Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);

  return NavManager;
}(React.Component);

var RouteManager =
/*#__PURE__*/
function (_React$Component5) {
  _inherits(RouteManager, _React$Component5);

  function RouteManager(props) {
    var _this6;

    _classCallCheck(this, RouteManager);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(RouteManager).call(this, props));
    _this6.listenUnregisterCallback = _this6.props.history.listen(_this6.historyChange.bind(_assertThisInitialized(_this6)));
    _this6.state = {
      viewStacks: {},
      hideView: _this6.hideView.bind(_assertThisInitialized(_this6)),
      setupIonRouter: _this6.setupIonRouter.bind(_assertThisInitialized(_this6)),
      removeViewStack: _this6.removeViewStack.bind(_assertThisInitialized(_this6)),
      renderChild: _this6.renderChild.bind(_assertThisInitialized(_this6)),
      transitionView: _this6.transitionView.bind(_assertThisInitialized(_this6))
    };
    return _this6;
  }

  _createClass(RouteManager, [{
    key: "hideView",
    value: function hideView(viewId) {
      var viewStacks = Object.assign({}, this.state.viewStacks);

      var _this$findViewInfoByI = this.findViewInfoById(viewId, viewStacks),
          view = _this$findViewInfoByI.view;

      if (view) {
        view.show = false;
        view.key = generateUniqueId();
        this.setState({
          viewStacks: viewStacks
        });
      }
    }
  }, {
    key: "historyChange",
    value: function historyChange(location, action) {
      this.setActiveView(location, action);
    }
  }, {
    key: "findViewInfoByLocation",
    value: function findViewInfoByLocation(location, viewStacks) {
      var view;
      var match;
      var viewStack;
      var keys = Object.keys(viewStacks);
      keys.some(function (key) {
        var vs = viewStacks[key];
        return vs.views.some(function (x) {
          var matchProps = {
            exact: x.routeData.childProps.exact,
            path: x.routeData.childProps.path || x.routeData.childProps.from,
            component: x.routeData.childProps.component
          };
          match = matchPath(location.pathname, matchProps);

          if (match) {
            view = x;
            viewStack = vs;
            return true;
          }

          return false;
        });
      });
      var result = {
        view: view,
        viewStack: viewStack,
        match: match
      };
      return result;
    }
  }, {
    key: "findViewInfoById",
    value: function findViewInfoById(id, viewStacks) {
      var view;
      var viewStack;
      var keys = Object.keys(viewStacks);
      keys.some(function (key) {
        var vs = viewStacks[key];
        view = vs.views.find(function (x) {
          return x.id === id;
        });

        if (view) {
          viewStack = vs;
          return true;
        } else {
          return false;
        }
      });
      return {
        view: view,
        viewStack: viewStack
      };
    }
  }, {
    key: "setActiveView",
    value: function setActiveView(location, action) {
      var _this7 = this;

      var viewStacks = Object.assign({}, this.state.viewStacks);

      var _this$findViewInfoByL = this.findViewInfoByLocation(location, viewStacks),
          enteringView = _this$findViewInfoByL.view,
          enteringViewStack = _this$findViewInfoByL.viewStack,
          match = _this$findViewInfoByL.match;

      var direction = location.state && location.state.direction;

      if (!enteringViewStack) {
        return;
      }

      var _this$findViewInfoByI2 = this.findViewInfoById(this.activeViewId, viewStacks),
          leavingView = _this$findViewInfoByI2.view;

      if (leavingView && leavingView.routeData.match.url === location.pathname) {
        return;
      }

      if (enteringView) {
        /**
         * If the page is being pushed into the stack by another view,
         * record the view that originally directed to the new view for back button purposes.
         */
        if (!enteringView.show && action === 'PUSH') {
          enteringView.prevId = leavingView && leavingView.id;
        }

        enteringView.show = true;
        enteringView.mount = true;
        enteringView.routeData.match = match;
        enteringViewStack.activeId = enteringView.id;
        this.activeViewId = enteringView.id;

        if (leavingView) {
          this.prevViewId = leavingView.id;

          if (leavingView.routeData.match.params.tab === enteringView.routeData.match.params.tab) {
            if (action === 'PUSH') {
              direction = direction || 'forward';
            } else {
              direction = direction || 'back';
              leavingView.mount = false;
            }
          }
          /**
           * If the leaving view is a Redirect, take it out of the rendering phase.
           */


          if (leavingView.element.type === Redirect) {
            leavingView.mount = false;
            leavingView.show = false;
          }

          if (leavingView.element.type === Route && leavingView.element.props.render) {
            if (leavingView.element.props.render().type === Redirect) {
              leavingView.mount = false;
              leavingView.show = false;
            }
          } else if (leavingView.element.type === Redirect) {
            leavingView.mount = false;
            leavingView.show = false;
          }
        }

        this.setState({
          viewStacks: viewStacks
        }, function () {
          var enteringEl = enteringView.ref && enteringView.ref.current ? enteringView.ref.current : undefined;
          var leavingEl = leavingView && leavingView.ref && leavingView.ref.current ? leavingView.ref.current : undefined;

          _this7.transitionView(enteringEl, leavingEl, enteringViewStack.routerOutlet, leavingEl && leavingEl.innerHTML !== '' ? direction : undefined); // Don't animate from an empty view

        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.listenUnregisterCallback && this.listenUnregisterCallback();
    }
  }, {
    key: "setupIonRouter",
    value: function setupIonRouter(id, children, routerOutlet) {
      var _this8 = this;

      var views = [];
      var activeId;
      var ionRouterOutlet = React.Children.only(children);
      React.Children.forEach(ionRouterOutlet.props.children, function (child) {
        views.push(createViewItem(child, _this8.props.history.location));
      });
      this.registerViewStack(id, activeId, views, routerOutlet, this.props.location);

      function createViewItem(child, location) {
        var viewId = generateUniqueId();
        var key = generateUniqueId();
        var element = child;
        var matchProps = {
          exact: child.props.exact,
          path: child.props.path || child.props.from,
          component: child.props.component
        };
        var match = matchPath(location.pathname, matchProps);
        var view = {
          id: viewId,
          key: key,
          routeData: {
            match: match,
            childProps: child.props
          },
          element: element,
          mount: true,
          show: !!match,
          ref: React.createRef()
        };

        if (!!match) {
          activeId = viewId;
        }

        return view;
      }
    }
  }, {
    key: "registerViewStack",
    value: function registerViewStack(stack, activeId, stackItems, routerOutlet, location) {
      var _this9 = this;

      this.setState(function (prevState) {
        var prevViewStacks = Object.assign({}, prevState.viewStacks);
        prevViewStacks[stack] = {
          activeId: activeId,
          views: stackItems,
          routerOutlet: routerOutlet
        };
        return {
          viewStacks: prevViewStacks
        };
      }, function () {
        var _this9$findViewInfoBy = _this9.findViewInfoById(activeId, _this9.state.viewStacks),
            activeView = _this9$findViewInfoBy.view;

        if (activeView) {
          _this9.prevViewId = _this9.activeViewId;
          _this9.activeViewId = activeView.id;
          var direction = location.state && location.state.direction;

          var _this9$findViewInfoBy2 = _this9.findViewInfoById(_this9.prevViewId, _this9.state.viewStacks),
              prevView = _this9$findViewInfoBy2.view;

          _this9.transitionView(activeView.ref.current, prevView && prevView.ref.current || undefined, routerOutlet, direction);
        }
      });
    }
  }, {
    key: "removeViewStack",
    value: function removeViewStack(stack) {
      var viewStacks = Object.assign({}, this.state.viewStacks);
      delete viewStacks[stack];
      this.setState({
        viewStacks: viewStacks
      });
    }
  }, {
    key: "renderChild",
    value: function renderChild(item) {
      var component = React.cloneElement(item.element, {
        computedMatch: item.routeData.match
      });
      return component;
    }
  }, {
    key: "findActiveView",
    value: function findActiveView(views) {
      var _this10 = this;

      var view;
      views.some(function (x) {
        var match = matchPath(_this10.props.location.pathname, x.routeData.childProps);

        if (match) {
          view = x;
          return true;
        }

        return false;
      });
      return view;
    }
  }, {
    key: "transitionView",
    value: function transitionView(enteringEl, leavingEl, ionRouterOuter, direction) {
      var _this11 = this;

      /**
       * Super hacky workaround to make sure ionRouterOutlet is available
       * since transitionView might be called before IonRouterOutlet is fully mounted
       */
      if (ionRouterOuter && ionRouterOuter.componentOnReady) {
        this.commitView(enteringEl, leavingEl, ionRouterOuter, direction);
      } else {
        setTimeout(function () {
          _this11.transitionView(enteringEl, leavingEl, ionRouterOuter, direction);
        }, 10);
      }
    }
  }, {
    key: "commitView",
    value: function () {
      var _commitView = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(enteringEl, leavingEl, ionRouterOuter, direction) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return ionRouterOuter.commit(enteringEl, leavingEl, {
                  deepWait: true,
                  duration: direction === undefined ? 0 : undefined,
                  direction: direction,
                  showGoBack: direction === 'forward',
                  progressAnimation: false
                });

              case 2:
                if (leavingEl && enteringEl !== leavingEl) {
                  /**
                   *  add hidden attributes
                  */
                  leavingEl.classList.add('ion-page-hidden');
                  leavingEl.setAttribute('aria-hidden', 'true');
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function commitView(_x, _x2, _x3, _x4) {
        return _commitView.apply(this, arguments);
      }

      return commitView;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this12 = this;

      return React.createElement(RouteManagerContext.Provider, {
        value: this.state
      }, React.createElement(NavManager, Object.assign({}, this.props, {
        findViewInfoById: function findViewInfoById(id) {
          return _this12.findViewInfoById(id, _this12.state.viewStacks);
        },
        findViewInfoByLocation: function findViewInfoByLocation(location) {
          return _this12.findViewInfoByLocation(location, _this12.state.viewStacks);
        }
      }), this.props.children));
    }
  }]);

  return RouteManager;
}(React.Component);

var RouteManagerWithRouter = withRouter(RouteManager);
RouteManagerWithRouter.displayName = 'RouteManager';

var IonReactRouter =
/*#__PURE__*/
function (_React$Component6) {
  _inherits(IonReactRouter, _React$Component6);

  function IonReactRouter() {
    _classCallCheck(this, IonReactRouter);

    return _possibleConstructorReturn(this, _getPrototypeOf(IonReactRouter).apply(this, arguments));
  }

  _createClass(IonReactRouter, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          children = _a.children,
          props = __rest(_a, ["children"]);

      return React.createElement(BrowserRouter, Object.assign({}, props), React.createElement(RouteManagerWithRouter, null, children));
    }
  }]);

  return IonReactRouter;
}(React.Component);

export { IonReactRouter, ViewManager };